import { Component, inject, input, output } from "@angular/core";
import { Container } from "@components/container/container";
import { Header } from "@components/header/header";
import { RewardCursorsProgression } from "@components/reward-cursors-progression/reward-cursors-progression";
import { SequenceResults } from "@components/sequence-results/sequence-results";
import { EducationLevelGroup } from "@domain/EducationLevel";
import { RdxTabsRootDirective, RdxTabsListDirective, RdxTabsTriggerDirective, RdxTabsContentDirective } from "@radix-ng/primitives/tabs";
import { AuthState } from "@states/auth.state";

@Component({
  selector: "app-sequence-end-screen",
  imports: [
    SequenceResults,
    RdxTabsRootDirective,
    RdxTabsListDirective,
    RdxTabsTriggerDirective,
    RdxTabsContentDirective,
    Container,
    Header,
    RewardCursorsProgression,
  ],
  template: `
    <app-container>
      <app-header (quitExerciser)="quitExerciser.emit()" />
      <div class="sequence-end-screen">
        @if (authState.currentUser()) {
          <div class="sequence-end-screen__content card-with-tabs card-medium" rdxTabsRoot defaultValue="results" orientation="horizontal">
            <div class="tabs-list" rdxTabsList>
              <div class="tab"><button type="button" class="tab-button" value="results" rdxTabsTrigger>Corrections</button></div>
              <div class="tab-list-gap"></div>
              <div class="tab"><button type="button" class="tab-button" value="reward-cursors-progression" rdxTabsTrigger>Récompenses</button></div>
            </div>
            <div class="tabs-content">
              <app-sequence-results data-testid="results" value="results" rdxTabsContent />
              <app-reward-cursors-progression
                data-testid="reward-cursors-progression"
                value="reward-cursors-progression"
                [educationLevelGroup]="educationLevelGroup()"
                rdxTabsContent
              />
            </div>
          </div>
        } @else {
          <div class="sequence-end-screen__content card card-medium">
            <app-sequence-results data-testid="results" />
          </div>
        }

        <div class="sequence-end__buttons">
          <button class="btn btn-secondary" (click)="this.quitExerciser.emit()">Quitter</button>
          <button class="btn btn-primary" (click)="this.startNewSequence.emit()">Continuer à pratiquer</button>
        </div>
      </div>
    </app-container>
  `,
  styles: `
    @use "responsive" as *;

    .sequence-end-screen {
      width: 100%;
    }

    .sequence-end-screen__content {
      margin: 0 auto 28px auto;
    }

    .sequence-end__buttons {
      width: 100%;
      display: flex;
      flex-direction: column;
      gap: 12px;
      align-items: stretch;
      justify-content: center;

      @include screenWidth("from-tablet") {
        align-items: center;
        flex-direction: row;
        gap: 24px;
      }

      button {
        @include screenWidth("from-tablet") {
          width: 300px;
        }
      }
    }
  `,
})
export class SequenceEndScreen {
  protected authState = inject(AuthState);

  educationLevelGroup = input.required<EducationLevelGroup>();

  quitExerciser = output<void>();
  startNewSequence = output<void>();
}
